export const METRIC_SYSTEM_UNIT = 'meters';
export const IMPERIAL_SYSTEM_UNIT = 'feet';

export const STANDARD_INCHES_FORMAT = 'in';
export const STANDARD_FEET_FORMAT = 'ft';

export const FOOT_INCHES_VALIDATION_REGEX = /^(((\d+)((\.(\d{1,2})))?)\s?(?:'|ft|feet)[ ]?(((?:1[0-1]|[0-9])(?:\.(\d{1,2}))?)\s?("|in|inches))?)$|^(((\d+)((\.(\d{1,2})))?)\s?(?:"|in|inches))$/;